import React, { useState, useEffect } from "react";
// Removido 'useParams' e 'Redirect' que não são mais necessários para obter o codevento
import { Link, useNavigate } from "react-router-dom"; 
import { api } from '../../services/api.js';
import Menu from "../../comum/Menu/index.jsx";
import './index.css';
import Footer from "../../comum/Footer/index.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import { AuthContext } from '../../comum/Context/auth.jsx';
import QRCode from "react-qr-code";
import folialogo from "./../../../public/Images/AEFLORcor.png";



function AeflorInscricao() {

    // NOVO: Obtém o codevento do localStorage (o mesmo local onde foi salvo no AeflorCard)
    const storedCodevento = localStorage.getItem("codevento");
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate(); // Usado para redirecionar se o codevento não for encontrado

    const [sucesso, setSucesso] = useState('');
    const [erro, setErro] = useState('');
    const [codtipo, setCodtipo] = useState(0);
    const [codIngresso, setCodIngresso] = useState('');
    const [nome, setNome] = useState('');
    const [tipo, setTipo] = useState('');
    const [idade, setIdade] = useState(0);
    const [valor, setValor] = useState(0);
    const [valortransporte, setValorTransporte] = useState(0);

    const [datanascimento, setDataNascimento] = useState('');

    const [somavalor, setSomavalor] = useState('');
    const [listaIngresso, setListaIngresso] = useState([]);
    const [mensagem, setMensagen] = useState('');
    const [aprovacao, setAprovacao] = useState(false);
    const [inscrito, setInscrito] = useState(0);
    const [ingresso, setIngresso] = useState('');
    // const chapa foi movido para o topo


    // Hook para checar se o codevento e a chapa existem
    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }
        if (!storedCodevento) {
            // Se não houver codevento, volta para a lista de eventos
            navigate("/arbor/aeflor");
            return;
        }
        CarregarDadosIngresso();
    }, [chapa, storedCodevento, navigate]);


    const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            console.log(e)
        }
    }


    function CarregarDadosIngresso() {
        if (!storedCodevento || !chapa) return; // Proteção adicional

        // Usa storedCodevento (do localStorage)
        api.get('/aeflor/evento/' + storedCodevento + '/' + chapa)
            .then(async (retorno) => {
                await
                    setListaIngresso(retorno.data);
                setValorTransporte(0);

                const lista = retorno.data.filter(ingresso => (ingresso.conf !== null));
                var sum = lista.reduce(function (accumulator, value) {
                    return accumulator + value.valor
                }, 0);
                setSomavalor(sum);

                const valort = retorno.data.filter(retorno => (retorno.transporte === 'S'));
                var vt = valort.reduce(function (accumulator, value) {
                    return (

                        accumulator + value.valort
                    )
                }, 0);
                setValorTransporte(vt);


                const qtde = retorno.data.filter(ingresso => (ingresso.conf !== null)).length;
                setInscrito(qtde);

            })
            .catch(err => {
                console.log(err);
            });
    }


    function zerarcampos() {
        setNome('');
        setTipo('');
    }
    function VisualizarIngresso(num, nome) {
        setIngresso('000000');
        // Usa storedCodevento (do localStorage)
        api.get('/aeflor/evento/' + storedCodevento + '/' + chapa + '/' + num)
            .then(async (retorno) => {
                await
                    setIngresso(retorno.data.resultado);
                setNome(nome);
            })
            .catch(err => {
                console.log(err);
            });
    }




    function CadastrarDependente() {
        const data = ({
            codevento: storedCodevento, // Usa storedCodevento
            chapa,
            nome,
            tipo,
            datanascimento
        });
        console.log(data);
        if (data.tipo === '' || data.nome === '') {
            setErro('S');
            setMensagen('É necessário informar o parentesco e o nome!');
        }
        else {
            api.post('/aeflor/evento/' + storedCodevento + '/' + chapa + '/DEPENDENTE', data)
                .then((retorno) => {
                    CarregarDadosIngresso();
                    setSucesso('S');
                    setMensagen('Ingresso cadastrado com sucesso!');
                })
                .catch(error => {
                    setErro('S');
                    setMensagen('Falha no envio do dependente!');
                });
        }
    }
    function ConfirmaWhatsApp(numingresso, nomepessoa) {
        setAprovacao(true);
        setCodIngresso(numingresso);
        setNome(nomepessoa);
    }

    function EnviaWhatsApp(numingresso) {
        api.post('/aeflor/evento/whatsapp/' + numingresso)
            .then((retorno) => {
                setSucesso('S');
                setAprovacao(false);
                setMensagen('Ingresso incluído na fila de envio, em instantes chegará!');
                CarregarDadosIngresso();
            })
            .catch((err) => {
                console.log(err);
            });
    }


    function IncluirOnibus() {
        api.post('/aeflor/transporte/' + storedCodevento + '/' + chapa) // Usa storedCodevento
            .then((retorno) => {
                CarregarDadosIngresso();
                setSucesso('S');
                setMensagen('Transporte alterado com sucesso!');
                setAprovacao(false);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    // O useEffect original foi substituído pelo novo no topo, que lida com o redirecionamento.
    /*
    useEffect(() => {
        CarregarDadosIngresso();
    }, []);
    */

    function AdicionarDependente() {
        const loc = {
            nome: "",
            tipo: "",
        };

        setListaIngresso([...listaIngresso, loc]);
    }



    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    // Renderiza um loading ou volta se estiver faltando o codevento (previnindo erros de API)
    if (!storedCodevento) {
        return (
             <div className="text-center p-5">
                <Menu modulo="ARBOR" />
                <p>Carregando informações do evento ou redirecionando...</p>
                <Footer />
            </div>
        );
    }


    return <>
        <Menu modulo="ARBOR" />
        {/* */}
        <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <img className="text-center foto-top fa-blink" src={folialogo} />
                    <div className="alterafoto">
                        <QRCode className="text-center fotoPerfil"
                            value={ingresso} />
                    </div>
                    <div>
                        <label className="font-espaco"><i className="fa fa-user" aria-hidden="true"></i> {nome}</label>
                    </div>
                </div>
            </div>
        </div>
        {/* */}
        <div className="container-fluid form-card-cadastro">
            <div className="row col-lg-6 offset-lg-3">
                <div className="col-12">
                    <div className="row">
                        <h4 align="center">Meus ingressos</h4>
                    </div>
                    <table className="table table-sm table-striped">
                        <thead>
                            <tr>
                                {/* Cabeçalhos comentados: mantido o original */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listaIngresso.map((ingresso, index) => {
                                    return <>
                                        {(() => {
                                            if (ingresso.conf !== null) {
                                                return (<tr key={ingresso.codingresso}>
                                                    <td colSpan={2}>
                                                        <label className="label-cor">Nome</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={ingresso.nome}
                                                            placeholder="nome" disabled />
                                                        <label className="label-cor">Código</label>

                                                        <input type="text" value={ingresso.conf}
                                                            className="form-control fontmenor"
                                                            placeholder="Tipo" disabled />

                                                    </td>
                                                    <td className="valor">

                                                        {ingresso.transporte === 'S' ?
                                                            <label className="label-cor">Vlr + Transp.</label>
                                                            :
                                                            <label className="label-cor">Valor</label>}
                                                        

                                                        <input type="text" value={formatNumber(ingresso.valor)}
                                                            className="form-control esquerda valor"
                                                            placeholder="Valor" disabled />
                                                        <label className="label-cor">Ingresso</label>
                                                        
                                                        <button type="button" className="btn btn-outline-primary btn-linha" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="" onClick={(e) => VisualizarIngresso(ingresso.codingresso, ingresso.nome)}>
                                                            <i className="fa fa-qrcode" aria-hidden="true" ></i> Abrir
                                                        </button>


                                                        {ingresso.status === 'W' || ingresso.status === 'Y' ?
                                                            <button type="button" className="btn btn-outline-success btn-linha" onClick={(e) => ConfirmaWhatsApp(ingresso.codingresso, ingresso.nome)}> 
                                                                <i className="bi bi-whatsapp" aria-hidden="true" ></i> WhatsApp
                                                            </button>
                                                            :
                                                            null
                                                        }
                                                    </td>

                                                </tr>)


                                            }
                                            else {
                                                return <tr key={'erro-'+index}><td>Erro ao carregar ingresso.</td></tr>
                                            }

                                        })()}
                                    </>
                                })
                            }
                        </tbody>
                    </table>

                    {(() => {
                        if (listaIngresso.length === 0) { // Corrigido para uma comparação estrita
                             return <div className="no-item">Nenhum registro encontrado</div>
                        }
                    })()}
                </div>
                {(() => {
                    if (valortransporte > 0 && inscrito > 0) {
                        return (
                            <div className="d-flex justify">
                                <label className="btn btn-outline-success me-3 cor"><i className="fa fa-bus" aria-hidden="true" ></i> R$ {formatNumber(valortransporte)}</label>
                            </div>
                        )
                    }
                })()}
                <div className="col-12 mt-3">
                    
                    <div>
                        <div className="d-flex justify">

                        </div>
                        <div className="d-flex justify-content-end">
                            <Link to={"#" + chapa} type="button" className="btn btn-outline-success me-6 cor">Total  {formatNumber(somavalor)}</Link>
                        </div>
                    </div>
                </div>


            </div>

            {
                sucesso === '' ?
                    null
                    :
                    <SweetAlert
                        success
                        showCloseButton
                        confirmBtnText="OK"
                        confirmBtnBsStyle="success"
                        onConfirm={() => setSucesso('')}
                        title="Sucesso"
                        reverseButtons={false}
                        openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                        closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                    >   {mensagem}
                    </SweetAlert>
            }

            {erro === '' ?
                null
                :
                <SweetAlert
                    error
                    showCloseButton
                    confirmBtnText="OK"
                    confirmBtnBsStyle="danger"
                    onConfirm={() => setErro('')}
                    title="Erro"
                    reverseButtons={false}
                    openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                    closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                >   {mensagem}
                </SweetAlert>
            }

            {aprovacao ?
                <SweetAlert
                    success
                    showCancel
                    showCloseButton
                    confirmBtnText="Sim"
                    confirmBtnBsStyle="success"
                    cancelBtnText="Não"
                    cancelBtnBsStyle="danger"
                    title="Confirmação"
                    onConfirm={() => EnviaWhatsApp(codIngresso)}
                    onCancel={() => setAprovacao(false)}
                    reverseButtons={false}
                    openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                    closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                >   Deseja enviar o ingresso por WhatsApp?<br></br>{nome}
                </SweetAlert> : null
            }
        </div>
        <Footer />
    </>
}

export default AeflorInscricao;